import { SystemSalaryRepository } from '../../domain/repositories/SystemSalaryRepository'
import { SystemSalaryModel } from '../models/SystemSalaryModel'
import type { CreateUpdateSystemSalaryEntity } from '../../domain/entities/CreateUpdateSystemSalary'
import {
  DriverSalariesService,
  SalarySystemsService,
  type SalarySystemAdminDto
} from '@/backend/market'
import type { SystemSalaryFilterEntity } from '../../domain/entities/SystemSalaryFilterEntity'
import { SystemSalaryFilterModel } from '../models/SystemSalaryFilterModel'
import { SystemSalaryMiniModel } from '../models/SystemSalaryMiniModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { SystemSalaryMiniEntity } from '../../domain/entities/SystemSalaryMiniEntity'
import type { SystemSalaryEntity } from '../../domain/entities/SystemSalaryEntity'
import { CreateUpdateSystemSalaryModel } from '../models/CreateUpdateSystemSalaryModel'

export class SystemSalaryRepositoryImpl implements SystemSalaryRepository {
  async getSystemsSalary(
    filterData: SystemSalaryFilterEntity
  ): Promise<PaginateEntity<SystemSalaryMiniEntity[]> | { error: true }> {
    const filterModel = new SystemSalaryFilterModel(filterData)
    try {
      const response = await SalarySystemsService.getSalarySystemsAdmin(filterModel)
      const systemSalaryMiniModels = response.items?.map((item) => new SystemSalaryMiniModel(item))
      const result = new PaginateEntity<SystemSalaryMiniModel[]>(response, systemSalaryMiniModels)

      return result
    } catch {
      return { error: true }
    }
  }
  async getSystemSalary(id: number): Promise<SystemSalaryEntity | { error: true }> {
    try {
      const response = await SalarySystemsService.getSalarySystemAdmin({ id })
      const systemSalaryModel = new SystemSalaryModel(response)

      return systemSalaryModel
    } catch {
      return { error: true }
    }
  }
  async createSystemSalary(
    salaryData: CreateUpdateSystemSalaryEntity
  ): Promise<{ success: true } | { error: true }> {
    const salaryDataModel = new CreateUpdateSystemSalaryModel(salaryData)
    try {
      await SalarySystemsService.postSalarySystemAdmin({ requestBody: salaryDataModel })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateSystemSalary(
    id: number,
    salaryData: CreateUpdateSystemSalaryEntity
  ): Promise<{ success: true } | { error: true }> {
    const salaryDataModel = new CreateUpdateSystemSalaryModel(salaryData)
    try {
      await SalarySystemsService.putSalarySystemAdmin({ id, requestBody: salaryDataModel })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async getDriverSystemSalary(
    driverSalaryId: number
  ): Promise<SystemSalaryEntity | { error: true }> {
    try {
      const response = await DriverSalariesService.getDriverSalaryByDriverAdmin({
        driverId: driverSalaryId
      })
      const systemSalaryModel = new SystemSalaryModel(response.salarySystem as SalarySystemAdminDto)

      return systemSalaryModel
    } catch {
      return { error: true }
    }
  }
  async updateDriverSystemSalary(
    driverId: number,
    salarySystemId: number
  ): Promise<{ success: true } | { error: true }> {
    try {
      await DriverSalariesService.putDriverSalaryAdmin({
        driverId,
        requestBody: {
          salarySystemId
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
